import "./_actualite.scss";

import cx from "classnames";
import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";
import {actualite} from "types/actualite";

import noPicture from "@/assets/iconNoPictureBig.png";
import Button from "@/components/Button/Button";
import {Skeleton} from "@/components/ui/skeleton";
import {formatDate} from "@/function/formatDate";

function Actualite({
  article,
  isLargeFormat = false,
}: {
  article: actualite;
  isLargeFormat?: boolean;
}): ReactElement {
  const dateDiffusion: string = article?.date ? formatDate(article?.date) : "";
  const ButtonRedirect: ReactElement | null = isLargeFormat ? (
    <Button label="Consultez l'offre" onClick={() => {}} variant="secondary" />
  ) : null;
  const navigate = useNavigate();
  return (
    <div
      className={cx(
        "actualite",
        "actualite-skeleton",
        isLargeFormat ? "largeActu" : "",
      )}
      onClick={() => navigate(`/actualite/${article.id}`)}>
      <div
        className="actualite-image"
        style={{
          backgroundImage: `url(${article?.image || noPicture})`,
        }}></div>

      <div className="actualite-info">
        <h2>{article?.title}</h2>
        <div className="actualite-info--contenu">
          <p id="date_actu">{dateDiffusion}</p>
          <div style={{display: "contents"}}>
            <p id="resume_actu">{article?.contenu}</p>
          </div>

          <div id="button_actu" onClick={() => console.log("clique")}>
            {ButtonRedirect}
          </div>
        </div>
        <div className="actualite-link">
          <p>En savoir plus</p>
        </div>
      </div>
    </div>
  );
}

function ActualiteSkeleton({
  isLargeFormat = false,
}: {
  isLargeFormat?: boolean;
}): ReactElement {
  return (
    <Skeleton
      className={cx(
        "actualite-skeleton",
        "skeleton-size",
        isLargeFormat ? "largeActu" : "",
      )}></Skeleton>
  );
}

export {Actualite, ActualiteSkeleton};
